<template>
  <div class="wrapper">
    <nav-header :title="$t('newSettings.applyGreen.title')" ref="nav" />
    <!-- loading -->
    <div class="loading-wrapper row-center" v-if="loadStatus == 'loading'">
      <md-activity-indicator type="roller" color="#1b6fdc" vertical>
        Loading...
      </md-activity-indicator>
    </div>
    <!-- load fail -->
    <div class="fail-wrapper row-center" v-else-if="loadStatus == 'fail'">
      <span class="fail-text">{{ errMsg }}</span>
    </div>
    <!-- load success -->
    <div class="success-wrapper" v-else-if="loadStatus == 'success'">
      <div class="status-wrapper col-center" v-if="status === 'applied'">
        <img src="@/images/status-waiting.svg" alt="Wait" class="icon" />
        <span class="text">
          {{ $t('apply.wait') }}
        </span>
        <span class="subtext wait-info-span">
          {{ $t('newSettings.applyGreen.waitInfo') }}
        </span>
        <md-button type="primary" @click="contactService">
          <span>{{ $t('newSettings.applyGreen.contactServiceMan') }}</span>
        </md-button>
      </div>
      <!-- 审核成功 -->
      <div class="status-wrapper col-center" v-else-if="status === 'adopted'">
        <img src="@/images/status-success.svg" alt="Success" class="icon" />
        <span class="text">{{ $t('apply.success') }}</span>
        <md-button type="primary" @click="goBack">
          <span>{{ $t('common.back') }}</span>
        </md-button>
      </div>
      <!-- 未通过 -->
      <div class="status-wrapper col-center" v-else-if="status === 'fail'">
        <img src="@/images/status-failed.svg" alt="Failed" class="icon" />
        <span class="text">{{ $t('newSettings.apply.fail') }}</span>
        <span class="subtext">
        {{ $t('newSettings.apply.failInfo') }}  {{ message }}
        </span>
        <!-- <md-button type="primary" @click="goBack">
          <span>{{ $t('common.back') }}</span>
        </md-button> -->
        <md-button type="primary" @click="applyAgain">
          <span>{{ $t('common.reapply') }}</span>
        </md-button>
      </div>
      <!-- 无需申请 -->
      <div class="status-wrapper col-center" v-else-if="status === 'ndlich'">
        <img src="@/images/status-failed.svg" alt="Failed" class="icon" />
        <span class="text">{{ $t('apply.tips.tipsLsit[0]') }}</span>
        <md-button type="primary" @click="goBack">
          <span>{{ $t('common.back') }}</span>
        </md-button>
      </div>
      <div class="form" v-else>
        <md-field :brief="$t('apply.personalInfo')">
          <div class="input-item">
            <h4 class="title tip-warning">{{$t('newSettings.applyGreen.warningInfoTitle')}}</h4>
            <div class="content">
                    <md-textarea-item
                  class="tip-warning"
                  :autosize="true"
                  :value="$t('newSettings.applyGreen.warningInfo')"
                  :max-height="300"
                  readonly
                />
 
            </div>
          </div>
          <div class="input-item">
            <h4 class="title">Mixin ID</h4>
            <div class="content">
              <md-input-item
                :value="userInfo.mixinId"
                type="digit"
                :readonly="true"
              ></md-input-item>
            </div>
          </div>
          <div class="input-item">
            <h4 class="title">{{ $t('apply.emergencyContact') }}</h4>
            <div class="content">
              <md-input-item
                v-model.trim="emergencyContact"
                type="text"
                :placeholder="$t('apply.emergencyContact')"
                :readonly="isSubmitting"
              ></md-input-item>
            </div>
          </div>
          <div class="input-item">
            <h4 class="title">{{ $t('apply.emergencyContactNumber') }}</h4>
            <div class="content">
              <md-input-item
                v-model.trim="emergencyContactNumber"
                type="phone"
                :placeholder="$t('apply.emergencyContactNumber')"
                :readonly="isSubmitting"
              >
                <div
                  class="input-item-left row-center"
                  slot="left"
                  @click="onSelectorShow"
                >
                  <span> {{ areaCode }}</span>
                  <span class="icon-dropdown"></span>
                </div>
              </md-input-item>
            </div>
          </div>
          <div class="input-item">
            <div class="title">
              {{ $t('apply.emergencyContactRelationship') }}
            </div>
            <div class="content">
              <md-input-item
                v-model.trim="emergencyContactRelationship"
                type="text"
                :placeholder="$t('apply.emergencyContactRelationship')"
                :readonly="isSubmitting"
              ></md-input-item>
            </div>
          </div>
          <md-button
            :type="submitDisabled ? 'disabled' : 'primary'"
            @click="onSubmit"
          >
            <md-activity-indicator
              v-if="isSubmitting"
              type="carousel"
              color="#fff"
            ></md-activity-indicator>
            <span v-else>{{ $t('common.submit') }}</span>
          </md-button>
        </md-field>
      </div>
    </div>
    <!-- <md-selector
      v-model="isShowSelector"
      :data="allowArea"
      max-height="100vw"
      large-radius
      :default-value="defaultIndex"
      @choose="updateAreaCode"
    ></md-selector> -->
    <md-popup v-model="isShowSelector" position="bottom" @hide="onPopupHide">
      <div class="popup-wrapper">
        <md-popup-title-bar
          large-radius
          only-close
          @cancel="onPopupChange(false)"
        />
        <div class="filter-bar">
          <md-input-item type="text" v-model.trim="filterKey" :placeholder="$t('apply.search')"></md-input-item>
        </div>
        <div class="popup-body">
          <md-scroll-view :scrolling-x="false" auto-reflow>
            <div class="scroll-body" v-if="filterArea.length">
              <div
                class="scroll-item"
                v-for="item in filterArea"
                :key="item.value"
                :class="item.value === defaultIndex ? 'active' : ''"
                @click="updateAreaCode(item)"
              >
                {{ item.label }}
              </div>
            </div>
            <div class="empty-wrapper row-center" v-else>
              <span>{{ $t('apply.noMatch') }}</span>
            </div>
          </md-scroll-view>
        </div>
      </div>
    </md-popup>
  </div>
</template>

<script>
import navHeader from '@/components/the-nav-bar.vue';
import {
  ActivityIndicator,
  Popup,
  Button,
  Field,
  RadioList,
  InputItem,
  Icon,
  Dialog,
  Selector,
  PopupTitleBar,
  ScrollView,
  TextareaItem,
} from 'mand-mobile';
import { mapState } from 'vuex';
import postLandun from '@/api/post-landun-international.js';
import getLandunStatus from '@/api/get-lundun-status';
export default {
  components: {
    navHeader,
    [ActivityIndicator.name]: ActivityIndicator,
    [Popup.name]: Popup,
    [Button.name]: Button,
    [Field.name]: Field,
    [RadioList.name]: RadioList,
    [InputItem.name]: InputItem,
    [Icon.name]: Icon,
    [Selector.name]: Selector,
    [Popup.name]: Popup,
    [PopupTitleBar.name]: PopupTitleBar,
    [ScrollView.name]: ScrollView,
    [TextareaItem.name]: TextareaItem,
  },
  computed: mapState({
    userInfo: state => state.userInfo,
    serviceUuid: state => state.serviceUuid,
    submitDisabled() {
      return (
        this.emergencyContactNumber.length < 4 ||
        !this.emergencyContact ||
        !this.emergencyContactRelationship ||
        this.isSubmitting
      );
    },
    allowArea() {
      return [
        '+86',
        '+1',
        '+7',
        '+20',
        '+27',
        '+30',
        '+31',
        '+32',
        '+33',
        '+34',
        '+36',
        '+39',
        '+40',
        '+41',
        '+43',
        '+44',
        '+45',
        '+46',
        '+47',
        '+48',
        '+49',
        '+51',
        '+52',
        '+53',
        '+54',
        '+55',
        '+56',
        '+57',
        '+58',
        '+60',
        '+61',
        '+62',
        '+63',
        '+64',
        '+65',
        '+66',
        '+81',
        '+82',
        '+84',
        '+90',
        '+91',
        '+92',
        '+93',
        '+94',
        '+95',
        '+98',
        '+211',
        '+212',
        '+213',
        '+216',
        '+218',
        '+220',
        '+221',
        '+222',
        '+223',
        '+224',
        '+225',
        '+226',
        '+227',
        '+228',
        '+229',
        '+230',
        '+231',
        '+232',
        '+233',
        '+234',
        '+235',
        '+236',
        '+237',
        '+238',
        '+239',
        '+240',
        '+241',
        '+242',
        '+243',
        '+244',
        '+245',
        '+247',
        '+248',
        '+249',
        '+250',
        '+251',
        '+252',
        '+253',
        '+254',
        '+255',
        '+256',
        '+257',
        '+258',
        '+260',
        '+261',
        '+262',
        '+263',
        '+264',
        '+265',
        '+266',
        '+267',
        '+268',
        '+269',
        '+291',
        '+297',
        '+298',
        '+299',
        '+350',
        '+351',
        '+352',
        '+353',
        '+354',
        '+355',
        '+356',
        '+357',
        '+358',
        '+359',
        '+370',
        '+371',
        '+372',
        '+373',
        '+374',
        '+375',
        '+376',
        '+377',
        '+378',
        '+380',
        '+381',
        '+382',
        '+385',
        '+386',
        '+387',
        '+389',
        '+420',
        '+421',
        '+423',
        '+500',
        '+501',
        '+502',
        '+503',
        '+504',
        '+505',
        '+506',
        '+507',
        '+508',
        '+509',
        '+590',
        '+591',
        '+592',
        '+593',
        '+594',
        '+595',
        '+596',
        '+597',
        '+598',
        '+599',
        '+670',
        '+673',
        '+675',
        '+676',
        '+677',
        '+678',
        '+679',
        '+680',
        '+682',
        '+684',
        '+685',
        '+687',
        '+688',
        '+689',
        '+691',
        '+784',
        '+809',
        '+852',
        '+853',
        '+855',
        '+856',
        '+880',
        '+886',
        '+960',
        '+961',
        '+962',
        '+963',
        '+964',
        '+965',
        '+966',
        '+967',
        '+968',
        '+970',
        '+971',
        '+972',
        '+973',
        '+974',
        '+975',
        '+976',
        '+977',
        '+992',
        '+993',
        '+994',
        '+995',
        '+996',
        '+998',
        '+1242',
        '+1246',
        '+1264',
        '+1268',
        '+1284',
        '+1340',
        '+1345',
        '+1441',
        '+1473',
        '+1649',
        '+1664',
        '+1671',
        '+1758',
        '+1767',
        '+1784',
        '+1787',
        '+1809',
        '+1868',
        '+1869',
        '+1876',
      ].map((code, index) => {
        return {
          label: code,
          value: index,
        };
      });
    },
    filterArea() {
      return this.allowArea.filter(item => {
        return item.label.indexOf(this.filterKey) > -1;
      });
    },
  }),
  data() {
    return {
      loadStatus: 'success',
      status: 'no', // no 未申请 / applied 已申请待审核 / adopted 已通过 / fail 拒绝 / ndlich 无需申请
      errMsg: '',
      areaCode: '',
      emergencyContact: '',
      emergencyContactNumber: '',
      emergencyContactRelationship: '',
      isSubmitting: false,
      isShowSelector: false,
      defaultIndex: '',
      filterKey: '',
    };
  },
  mounted() {
    this.loadStatus = 'loading';
    this.areaCode = this.allowArea[0].label;
    this.defaultIndex = 0;
    getLandunStatus()
      .then(data => {
        const d = data.data;
        if (!d.hasKyc) {
          Dialog.confirm({
            icon: 'icon-smile',
            iconSvg: true,
            content: this.$t('apply.kycFirst'),
            cancelText: this.$t('common.cancel'),
            confirmText: this.$t('apply.goKyc'),
            onCancel: () => {
              this.goBack();
            },
            onConfirm: () => {
              this.$router.push('/mine/payInfo');
            },
          });
        } else {
          this.status = d.status;
          this.message = d.reasonZhCn;
          this.loadStatus = 'success';
        }
      })
      .catch(err => {
        this.loadStatus = 'fail';
        this.errMsg = err.message;
      });
  },
  methods: {
    onPopupHide() {
      this.filterKey = '';
    },
    onPopupChange(value = !this.isShowSelector) {
      this.isShowSelector = value;
    },
    goBack() {
      this.$refs.nav && this.$refs.nav.goBack();
    },
    onSelectorShow() {
      this.isShowSelector = true;
    },
    updateAreaCode(obj) {
      this.areaCode = obj.label;
      this.defaultIndex = obj.value;
      this.isShowSelector = false;
    },
    contactService(){
      window.open(
        `https://mixin.one/codes/${this.serviceUuid}`,
        '_blank',
        'noopener',
      );
    },
    onSubmit() {
      this.isSubmitting = true;
      postLandun({
        emergency: this.emergencyContact,
        emergency_number: `${this.areaCode}${this.emergencyContactNumber}`,
        emergency_relationship: this.emergencyContactRelationship,
      })
        .then(() => {
          this.isSubmitting = false;
          this.status = 'applied';
        })
        .catch(err => {
          this.isSubmitting = false;
          Dialog.alert({
            icon: 'fail',
            title: this.$t('error.occur'),
            content: err.message,
            confirmText: this.$t('common.confirm'),
          });
        });
    },
    applyAgain() { //重新申请
      this.status = 'no';
    },
  },
};
</script>

<style lang="stylus" scoped>
>>>.md-textarea-item__textarea
  font-size 3.73vw !important
  color red !important

>>>.wait-info-span 
   color red !important
.loading-wrapper {
  min-height: 80vw;
}

.fail-wrapper {
  min-height: 40vw;
  color: color-text-caption;
}

.status-wrapper {
  min-height: 80vw;

  .md-icon, .icon {
    font-size: 16vw;
    width: 16vw;
    height: 16vw;
  }

  .text {
    margin-top: 9.6vw;
    font-size: 4.8vw;
  }

  .subtext {
    margin: 2.13vw 9.6vw 0;
    text-align: center;
  }

  .md-button {
    margin-top: 14.4vw;
    width: 60vw;
  }
}

.form {
  padding-bottom: 40vw;

  .input-item {
    padding: 2.67vw 0;
  }

  .md-input-item {
    box-sizing: border-box;
    width: 100%;
    padding: 0 2.67vw;
    border: 0.27vw solid #eaf1f3;
    border-radius: 2.67vw;
    background: #F8FBFC;
  }

  .title {
    margin: 0 0 2.67vw 0;
    width: 100%;
    font-size: 3.73vw;
    font-weight: bold;
    text-transform: capitalize;
  }

  .input-item-left {
    min-width: 15vw;
    font-size: 3.73vw;
    font-weight: bold;
    color: color-text-base;

    .icon-dropdown {
      margin-left: 2.13vw;
      width: 0;
      height: 0;
      border-top: 1.6vw solid currentColor;
      border-left: 1.2vw solid transparent;
      border-right: 1.2vw solid transparent;
    }
  }

  .md-button {
    margin-top: 4.8vw;
  }

  & >>> {
    .md-field-item-content:before {
      content: none;
    }

    .md-activity-indicator-svg {
      width: 16vw !important;
      height: 4vw !important;
    }
  }
}

.popup-wrapper {
  .filter-bar {
    padding: 4.8vw;
    background: #fff;

    .md-input-item {
      border: 0.27vw solid #eaf1f3;
      padding: 0 2.67vw;
      border-radius: 2.67vw;
      background: #f8fbfc;

      & >>> {
        .md-field-item-content:before {
          content: none;
        }

        .md-field-item-left {
          margin-right: 5.33vw;
          color: #B4C2C7;
        }
      }
    }
  }

  .popup-body {
    height: 100vw;
    background: #fff;
  }

  .scroll-body {
    padding-bottom: 40vw;

    .scroll-item {
      text-align: center;
      padding: 0 4.8vw;
      font-size: 4.27vw;
      line-height: 11.73vw;
      min-height: 11.73vw;

      &:active {
        background: rgba(0, 0, 0, 0.01);
      }

      &.active {
        color: color-primary;
      }
    }
  }

  .empty-wrapper {
    min-height: 20vw;
  }
}
</style>